import React from 'react';
import { Dialog, DialogContent, DialogTitle, Button, DialogActions } from '@mui/material';
import MicOffIcon from '@mui/icons-material/MicOff';
import { useTranslation } from 'react-i18next';
import { useStoreByName } from '../../../hooks/use-stores.hooks';

interface MicrophoneOffModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * מודל שמציג הודעה שהמיקרופון נכבה ומאפשר למשתמש להמשיך את השינון
 */
const MicrophoneOffModal: React.FC<MicrophoneOffModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const speechRecognitionStore = useStoreByName('speechRecognitionStore') as any;

  const handleContinue = () => {
    // המשך שינון - זה בעצם קורא ל-toggleListening שמשנה את isPaused
    if (speechRecognitionStore?.toggleListening) {
      speechRecognitionStore.toggleListening();
    }
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        // מונע סגירה בלחיצה על הרקע או Escape - רק דרך הכפתור
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
      className="microphone-off-modal"
    >
      <DialogTitle component="h3">
        <MicOffIcon sx={{ color: "white", fontSize: 64, background: "#b689e3", borderRadius: "50%" }} />
        {t('microphoneTurnedOff')}
      </DialogTitle>
      <DialogContent sx={{
        textAlign: 'center',
        padding: '32px',
        position: 'relative'
      }}>
        <div style={{
          fontSize: '16px',
          lineHeight: '24px'
        }}>
          {t('microphoneTurnedOffMessage')}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="import-button circle"
          onClick={handleContinue}
          variant="contained"
        >
          {t('continueRecitation')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MicrophoneOffModal;

